<form [formGroup]="form">
  <mat-form-field2 class="mat-block">
    <input
      type="text"
      i18n-matTooltip
      matTooltip="Choose a category or create a new one by typing into the field below."
      i18n-placeholder
      placeholder="Category"
      matInput
      formControlName="category"
      [matAutocomplete]="auto"
      required
    />
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let category of categories$ | async" [value]="category.value">
        {{ category.label }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.get('category').touched && form.get('category').hasError('required')" i18n>
      Category is required
    </mat-error>
  </mat-form-field2>
  <div class="row">
    <div class="col-md-6 mb-3">
      <div class="card p-3 h-100">
        <app-automation-date-form
          [form]="form.get('date')"
          label="Expense Date"
          [showHours]="false"
          [event]="eventCtrl.value"
        ></app-automation-date-form>
        <mat-error *ngIf="form.get('date').hasError('invalid')" i18n>Due date may be after the expense date</mat-error>
        <!-- <mat-error -->
        <!--   *ngIf=" -->
        <!--     isBookingConfirmedOnBookingCreatedEvent(eventCtrl.value, form.get('date').get('base').value) -->
        <!--   " -->
        <!--   >When an inquiry is created, the booking might not be confirmed, in which case this automation will be -->
        <!--   skipped -->
        <!-- </mat-error> -->
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="card p-3 h-100">
        <app-automation-date-form
          [form]="form.get('due')"
          label="Due Date"
          [showHours]="false"
          [event]="eventCtrl.value"
        ></app-automation-date-form>
        <mat-error *ngIf="form.get('due').hasError('invalid')" i18n>Due date may be after the expense date</mat-error>
        <mat-error
          *ngIf="isBookingConfirmedOnBookingCreatedEvent(eventCtrl.value, form.get('due').get('base').value)"
          i18n
        >
          When an inquiry is created, the booking might not be confirmed, in which case the due date will be skipped.
        </mat-error>
      </div>
    </div>

    <div class="col-md-3">
      <mat-form-field2 class="mat-block">
        <input matInput decimal required i18n-placeholder placeholder="Amount" formControlName="amount" type="number" />
        <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
          Amount is required
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-3">
      <mat-form-field2 class="mat-block">
        <mat-select formControlName="method" i18n-placeholder placeholder="Payment Method">
          <mat-option *ngFor="let method of methodOptions" [value]="method.value">{{ method.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('method').touched && form.get('method').hasError('required')" i18n>
          Payment Method is required
        </mat-error>
      </mat-form-field2>
    </div>
    <ng-template *ngIf="isAdmin" [ngTemplateOutlet]="approveField"></ng-template>
    <ng-template
      *ngIf="!isAdmin && (approvable$ | async)?.amount >= form.get('amount').value"
      [ngTemplateOutlet]="approveField"
    ></ng-template>
    <ng-template #approveField>
      <div class="col-md-3">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="approval_status" i18n-placeholder placeholder="Approval Status">
            <mat-option *ngFor="let item of approvalStatuses" [value]="item.id">{{ item.label }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
    </ng-template>

    <div class="col-md-12">
      <mat-form-field2 class="mat-block">
        <textarea
          matInput
          formControlName="description"
          #notes
          maxlength="500"
          rows="3"
          i18n-placeholder
          placeholder="Description"
          cdkTextareaAutosize
        ></textarea>
        <mat-hint align="end">{{ notes.value?.length || 0 }}/500</mat-hint>
      </mat-form-field2>
    </div>
  </div>
  <app-upload-box
    [options]="getUploadBoxOptions()"
    [showFileList]="false"
    *ngIf="attachments.length < maxAttachments"
    (complete)="onUploadComplete($event)"
  ></app-upload-box>
  <div *ngFor="let item of attachments; let i = index" class="d-flex align-items-center gap-3">
    <div class="text-primary text-xxl">
      <i class="" [ngClass]="item.name | fileIcon"></i>
    </div>
    <div class="mr-4">{{ item.name }}</div>
    <div class="flex-fill text-light">
      {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'HH:mm' }}* {{ item.user }}*
      {{ item.size | fileSize }}
    </div>
    <div>
      <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)"
        ><i class="cs-icon cs-icon-download"></i>
      </a>
      <a href="javascript:;" class="btn btn-light-danger btn-sm" (click)="onDeleteAttachment(item)"
        ><i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
</form>
